/** Spec §3.b.4 — waking a project at the active cap must ask one of the
 *  active ones to rest: never silently exceed the cap, never hard-block. */
export function wakeDecision(promotedCount: number, cap: number): "promote" | "swap" {
  return promotedCount >= cap ? "swap" : "promote";
}

/** The two lifeProject configs a swap writes. Waking clears a scheduled wake
 *  month (same rule as a plain wake); resting keeps everything else intact.
 *  Independent type parameters (rather than one shared T) because wake/rest
 *  are two different projects' configs — they need not share a shape beyond
 *  the LP bound, e.g. one may carry whyNow and the other spaceName. */
export function swapPatches<
  A extends { status: "promote" | "someday"; wakeAt?: string },
  B extends { status: "promote" | "someday"; wakeAt?: string }
>(wake: A, rest: B): { wake: A; rest: B } {
  return {
    wake: { ...wake, status: "promote", wakeAt: undefined },
    rest: { ...rest, status: "someday" },
  };
}
